import styled from 'styled-components';
import { StyledEmbeddedComponentView } from '../EmbeddedComponentView.style';

export const StyledEmbeddedComponentContainerView = styled.div`
  & ${StyledEmbeddedComponentView} {
    margin-bottom: 8px;
  }
  min-height: 24px;
`;